import React from 'react';
import {
  Cenniki,
  CiagiNumeracjePageLazy,
  FileUploaderPageLazy,
  JezykiPageLazy,
  KategorieCechyPageLazy,
  KategoriePageLazy,
  SklepyPageLazy,
  StronyStatycznePageLazy,
  TlumaczeniaPageLazy,
  TowaryPageLazy,
  UzytkownicyPageLazy,
  WalutyPageLazy,
  KrajePageLazy,
  ZamowieniaPageLazy,
  ParametryPageLazy,
  LogiTestPageLazy,
  KomunikatoryLazy,
  ReklamyPageLazy,
  SklepyTowaryWyklczenia,
  KlienciListaPageLazy,
  WiadomosciSzablony,
  RaportyStartowePageLazy,
  CenyWyliczonePageLazy,
  TowaryOpinieLazy,
  PromoPageLazy,
  JednostkiMiarLazy,
  CechyGrupyPageLazy,
  CechySlownikiLazy,
  CechyPageLazy,
  FormyPlatnosciPageLazy,
  CechyTowaryTypyPageLazy,
  CechyTowaryMarkiLazy,
  CechyTowaryModeleLazy,
  CechyTowaryTypyEdycjaLazy,
  CechyTowaryTypyWariantyDostepne,
  CechyWariantyLazy,
  OpisywanieTowarowPageLazy,
  KategorieProduktoweLazy,
  CechyZdjeciaTypyLazy,
  CechyPlikiTypyLazy,
  TowaryPowiazaniaLazy,
  TowaryPowiazaniaCechyWspolneLazy,
  TowaryPowiazaniaWarunkiLazy,
  CechyKanalyTypyLazy,
  TowaryImportExportLazy,
  KreatorDefinicjeTypyLazy,
  CechyTowaryTypySzablonyLazy,
  TowaryCenaLazy,
  KreatoryModeleLazy,
  TlumaczeniaSeoLazy,
  TlumaczeniaRoutesLazy,
  KategorieTowaryPolaczLazy,
  TowarKategoriePolaczLazy,
  TransactionsWithActionsPageLazy,
  WalidacjaImion,
  WalidacjeKodowPocztowych,
  AnkietyPageLazy,
  WysylkiCzasyDostawyLazy,
  UzytkownicyWebCzarnaListaListaLazy,
  BlogPageLazy, TowarPodgladPageLazy, ZamowienieEdycjaLazy,
  RabatyPageLazy
} from '../pages';
import { paths } from './app-paths';

const szef = 1;
const administrator = 2;
const zarzadzanieCenami = 4;
const zarzadzanieProduktami = 8;
const obslugaZamowien = 16;
const komunikacjaZKlientami = 32;
const marketing = 64;
const cms = 128;
const agencjaSEO = 256;
const obslugaB2B = 512;
const DostepDoApi = 65536;

const rawNavItems = [
  {
    text: 'Home',
    roles: [szef],
    path: paths.RaportyStartowePage,
    component: RaportyStartowePageLazy
  },
  {
    text: 'TlumaczeniaSeo',
    roles: [],
    path: paths.TlumaczeniaSeoAgencjaPage,
    component: TlumaczeniaSeoLazy
  },
  {
    text: 'Transakcje',
    roles: [obslugaZamowien, obslugaB2B],
    items: [
      {
        text: 'Transakcje wymagające akcji',
        roles: [],
        path: paths.TransactionsWithActionsPage,
        component: TransactionsWithActionsPageLazy,
        customProps: {
          transakcjeWymagajaceAkcji: true
        }
      },
      {
        text: 'Koszyki',
        roles: [],
        path: paths.KoszykiPage,
        customProps: { type: 'Koszyk' },
        component: ZamowieniaPageLazy
      },
      {
        text: 'Zamowienia',
        roles: [],
        path: paths.ZamowieniaPage,
        component: ZamowieniaPageLazy
      },
      {
        text: 'Zamowienia Edycja',
        roles: [],
        path: paths.ZamowienieEdycja,
        component: ZamowienieEdycjaLazy,
        visible: false
      }
    ]
  },
  {
    text: 'Klienci',
    pimModeDependent: true,
    roles: [obslugaZamowien, komunikacjaZKlientami, obslugaB2B],
    items: [
      {
        text: 'Wiadomosci',
        roles: [],
        path: paths.KomunikatoryPage,
        component: KomunikatoryLazy
      },
      {
        text: 'Lista',
        roles: [],
        path: paths.KlienciListaPage,
        component: KlienciListaPageLazy
      },
      {
        text: 'Czarna Lista',
        roles: [],
        path: paths.UzytkownicyWebCzarnaListaPage,
        component: UzytkownicyWebCzarnaListaListaLazy
      }
    ]
  },
  {
    text: 'Ceny',
    roles: [zarzadzanieCenami],
    items: [
      {
        text: 'TowaryCena',
        roles: [],
        path: paths.TowaryCena,
        component: TowaryCenaLazy
      },
      {
        text: 'Cenniki',
        roles: [],
        path: paths.CennikiPage,
        component: Cenniki
      },
      {
        separator: true
      },
      {
        text: 'Ceny',
        roles: [],
        path: paths.CenyWyliczonePage,
        component: CenyWyliczonePageLazy
      },
      {
        separator: true
      },
      {
        text: 'Promocje',
        roles: [],
        path: paths.PromoPage,
        component: PromoPageLazy
      },
      {
        text: 'Rabaty',
        roles: [],
        path: paths.RabatPage,
        component: RabatyPageLazy
      }
    ]
  },
  {
    text: 'Marketing',
    roles: [marketing],
    items: [
      {
        text: 'Reklamy',
        roles: [],
        path: paths.ReklamyPage,
        component: ReklamyPageLazy
      },
      {
        text: 'Ankiety',
        roles: [],
        path: paths.AnkietyPage,
        component: AnkietyPageLazy
      }
    ]
  },
  {
    text: 'Towary',
    roles: [agencjaSEO, zarzadzanieProduktami],
    items: [
      {
        text: 'Podgląd',
        roles: [],
        path: paths.TowarPodglad,
        component: TowarPodgladPageLazy,
        visible: false
      },
      {
        text: 'Lista',
        roles: [],
        path: paths.TowaryPage,
        component: TowaryPageLazy
      },
      {
        text: 'Opisywanie',
        roles: [],
        path: `${paths.OpisywanieTowarowPage}/`,
        component: OpisywanieTowarowPageLazy
      },
      {
        text: 'OpisywanieZbiorcze',
        roles: [],
        path: paths.OpisywanieTowarowZbiorczePage,
        component: OpisywanieTowarowPageLazy,
        customProps: {
          isZbiorcze: true
        }
      },
      {
        text: 'Towary_Kategorie_Polacz',
        roles: [],
        path: paths.TowarKategoriePolaczPage,
        component: TowarKategoriePolaczLazy
      },
      {
        separator: true
      },
      {
        text: 'SklepyTowaryWykluczenia',
        roles: [],
        path: paths.SklepyTowaryWykluczeniaPage,
        component: SklepyTowaryWyklczenia
      },
      {
        separator: true
      },
      {
        roles: [],
        text: 'Towary Opinie',
        path: paths.TowaryOpiniePage,
        component: TowaryOpinieLazy
      }
    ]
  },
  {
    text: 'PIM',
    roles: [zarzadzanieProduktami],
    items: [
      {
        text: 'Cechy',
        roles: [],
        items: [
          {
            text: 'Cechy_Definicje',
            roles: [],
            path: paths.CechyPage,
            component: CechyPageLazy
          },
          {
            text: 'Grupy_Cech',
            roles: [],
            path: paths.CechyGrupyPage,
            component: CechyGrupyPageLazy
          },

          {
            separator: true
          },
          {
            text: 'Slowniki',
            roles: [],
            path: paths.CechySlowniki,
            component: CechySlownikiLazy
          },
          {
            text: 'Jednostki_Miar',
            roles: [],
            path: paths.JednostkiMiar,
            component: JednostkiMiarLazy
          },
          {
            separator: true
          },
          {
            text: 'Warianty',
            roles: [],
            path: paths.CechyWarianty,
            component: CechyWariantyLazy
          },
          {
            separator: true
          },
          {
            text: 'Typy_Towarow',
            roles: [],
            path: paths.CechyTowaryTypyEdycja,
            component: CechyTowaryTypyEdycjaLazy
          },
          {
            text: 'Cechy_dla_typow_towarow',
            roles: [],
            path: paths.CechyTowaryTypyPage,
            component: CechyTowaryTypyPageLazy
          },
          {
            text: 'Warianty_dla_typow_towarow',
            roles: [],
            path: paths.CechyTowaryTypyWariantyDostepne,
            component: CechyTowaryTypyWariantyDostepne
          },
          {
            separator: true
          },
          {
            text: 'Cechy_Zdjecia_Typy',
            roles: [],
            tooltip: 'Cechy_Zdjecia_Typy_tooltip',
            path: paths.CechyZdjeciaTypyPage,
            component: CechyZdjeciaTypyLazy
          },
          {
            text: 'Cechy_Pliki_Typy',
            roles: [],
            tooltip: 'Cechy_Pliki_Typy_tooltip',
            path: paths.CechyPlikiTypyPage,
            component: CechyPlikiTypyLazy
          },
          {
            separator: true
          },
          {
            text: 'Cechy_Kanaly_Typy',
            roles: [],
            path: paths.CechyKanalyTypyPage,
            component: CechyKanalyTypyLazy
          },
          {
            separator: true
          },
          {
            text: 'Cechy_Szablony',
            roles: [],
            path: paths.CechyTowaryTypySzablony,
            component: CechyTowaryTypySzablonyLazy
          }
        ]
      },
      {
        text: 'Towary',
        roles: [],
        items: [
          {
            text: 'Marki',
            roles: [],
            path: paths.CechyTowaryMarkiPage,
            component: CechyTowaryMarkiLazy
          },
          {
            text: 'Modele',
            roles: [],
            path: paths.CechyTowaryModelePage,
            component: CechyTowaryModeleLazy
          }
        ]
      },
      {
        text: 'Opisywanie',
        roles: [],
        items: [
          {
            text: 'Towary',
            roles: [],
            path: paths.OpisywanieTowarowPage,
            component: OpisywanieTowarowPageLazy
          },
          {
            text: 'Towary_Import_Export',
            roles: [],
            path: paths.TowaryImportExport,
            component: TowaryImportExportLazy
          }
        ]
      },
      {
        text: 'Kategorie_Produktowe',
        roles: [],
        items: [
          {
            text: 'Lista',
            roles: [],
            path: paths.KategorieProduktowePage,
            component: KategorieProduktoweLazy
          },
          {
            text: 'Kategorie_Cechy_Ustawienia',
            roles: [],
            path: paths.KategoriePage,
            component: KategoriePageLazy
          },
          {
            text: 'Kategorie_Towary_Polacz',
            roles: [],
            path: paths.KategorieTowaryPolaczPage,
            component: KategorieTowaryPolaczLazy
          },
          {
            text: 'Kategorie_Cechy_Definicje',
            roles: [],
            path: paths.KategorieCechyPage,
            component: KategorieCechyPageLazy
          }
        ]
      },
      {
        text: 'Powiazania_Produktowe',
        roles: [],
        items: [
          {
            text: 'Towary_Powiazania',
            roles: [],
            path: paths.TowaryPowiazaniaPage,
            component: TowaryPowiazaniaLazy
          },
          {
            text: 'Towary_Powiazania_Wspolne',
            roles: [],
            path: paths.TowaryPowiazaniaCechyWspolnePage,
            component: TowaryPowiazaniaCechyWspolneLazy
          },
          {
            text: 'Towary_Powiazania_Warunki',
            roles: [],
            path: paths.TowaryPowiazaniaWarunkiPage,
            component: TowaryPowiazaniaWarunkiLazy
          }
        ]
      },
      {
        text: 'Kreator_Konfiguracji',
        roles: [],
        items: [
          {
            text: 'Kreatory_Produktow',
            roles: [],
            path: paths.KreatoryProduktowPage,
            component: KreatoryModeleLazy
          },
          {
            text: 'Kreator_Definicje_Typy',
            roles: [],
            path: paths.KreatorDefinicjeTypyPage,
            component: KreatorDefinicjeTypyLazy
          }
        ]
      }
    ]
  },
  {
    text: 'CMS',
    roles: [cms],
    items: [
      {
        text: 'Tlumaczenia',
        roles: [],
        items: [
          {
            text: 'Tlumaczenia',
            roles: [],
            path: paths.TlumaczeniaPage,
            component: TlumaczeniaPageLazy
          },
          {
            text: 'TlumaczeniaSeo',
            roles: [],
            path: paths.TlumaczeniaSeoPage,
            component: TlumaczeniaSeoLazy
          },
          {
            text: 'Routes',
            roles: [],
            path: paths.TlumaczeniaRoutesPage,
            component: TlumaczeniaRoutesLazy
          }
        ]
      },
      {
        text: 'Manager Plików',
        roles: [],
        path: paths.FileUploaderPage,
        component: FileUploaderPageLazy
      },
      {
        text: 'Strony Statyczne',
        roles: [],
        path: paths.StronyStatycznePage,
        component: StronyStatycznePageLazy
      },
      {
        text: 'Blog',
        roles: [],
        path: paths.BlogPage,
        component: BlogPageLazy
      },
      {
        text: 'Jezyki',
        roles: [],
        path: paths.JezykiPage,
        component: JezykiPageLazy
      }
    ]
  },
  {
    text: 'Konfiguracja',
    roles: [],
    items: [
      {
        text: 'Parametry',
        roles: [],
        path: paths.ParametryPage,
        component: ParametryPageLazy
      },
      {
        text: 'Formy_platnosci',
        roles: [],
        path: paths.FormyPlatnosciPage,
        component: FormyPlatnosciPageLazy
      },
      {
        text: 'Sklepy',
        roles: [],
        path: paths.SklepyPage,
        component: SklepyPageLazy
      },
      {
        text: 'Waluty',
        roles: [],
        path: paths.WalutyPage,
        component: WalutyPageLazy
      },
      {
        text: 'Kraje',
        roles: [],
        path: paths.KrajePage,
        component: KrajePageLazy
      },
      {
        text: 'Ciagi_numeracji',
        roles: [],
        path: paths.CiagiNumeracjePage,
        component: CiagiNumeracjePageLazy
      },
      {
        text: 'WiadomosciSzablony',
        roles: [],
        path: paths.WiadomosciSzablonyPage,
        component: WiadomosciSzablony
      },
      {
        text: 'Wysyłki Czasy Dostawy',
        roles: [],
        path: paths.WysylkiCzasyDostawyPage,
        component: WysylkiCzasyDostawyLazy
      }
    ]
  },
  {
    text: 'Administracja',
    roles: [],
    items: [
      {
        text: 'Uzytkownicy',
        roles: [],
        path: paths.UzytkownicyPage,
        component: UzytkownicyPageLazy
      },
      {
        text: 'Logi',
        roles: [],
        path: paths.LogiPage,
        component: LogiTestPageLazy
      },
      {
        text: 'Walidacja Imion',
        roles: [],
        path: paths.WalidacjaImion,
        component: WalidacjaImion
      },
      {
        text: 'WalidacjaKodowPocztowych',
        roles: [],
        path: paths.WalidacjeKodowPocztowych,
        component: WalidacjeKodowPocztowych
      }
    ]
  }
];

export const getRawNavItems = (pimOnly) => {
  return rawNavItems.map((navItem) => {
    if (navItem.pimModeDependent) {
      const { ...dependendNavItem } = navItem;

      delete dependendNavItem.pimModeDependent;

      return {
        ...dependendNavItem,
        hide: pimOnly
      };
    }
    return navItem;
  });
};
